import { Nullable } from '@ps/utils';

export interface RespondentListUploadState {
  loading: boolean;
  error: Nullable<string>;
  items: string[];
}

export const INITIAL_RESPONDENT_LIST_UPLOAD_STATE: RespondentListUploadState = {
  loading: false,
  error: null,
  items: [],
};
